<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { SbList, SbListItem, SbListLabel, SbListSection } from "@unio/saltbox-ui"

import NarrowPage from "@/components/NarrowPage.vue"
import NavListItem from "@/components/NavListItem.vue"
import ProfileHeader from "@/components/ProfileHeader.vue"
import { useAuthUser } from "@/composables/useAuthUser"
import { useNavbar } from "@/composables/useNavbar"
import { ICON } from "@/lib/icons"
import { editProfilePath, editProfilePasswordPath, sessionPath } from "@/routes"

const { title } = useNavbar({ title: "Profile" })
const { authUser, userName, avatarSrc } = useAuthUser()

function signOut() {
  router.delete(sessionPath())
}
</script>

<template>
  <Head :title="title" />

  <NarrowPage>
    <ProfileHeader
      :avatar-src="avatarSrc"
      :initials="authUser?.initials"
      :name="userName"
      :email="authUser?.email_address ?? ''"
    />

    <!-- Actions -->
    <SbList bordered separator>
      <NavListItem
        :to="editProfilePath()"
        :icon="ICON.edit"
        label="Edit Profile"
        caption="Update your name, email, and photo"
      />
      <NavListItem
        :to="editProfilePasswordPath()"
        :icon="ICON.password"
        label="Change Password"
        caption="Update your account password"
      />
      <SbListItem clickable @click="signOut">
        <SbListSection avatar>
          <UIcon :name="ICON.signOut" class="text-muted size-5" />
        </SbListSection>
        <SbListSection>
          <SbListLabel>Sign Out</SbListLabel>
          <SbListLabel caption>End your session</SbListLabel>
        </SbListSection>
      </SbListItem>
    </SbList>
  </NarrowPage>
</template>
